require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2018-05-15-place-ii.json") })
        }
      }, "path---works-2018-05-15-place-ii");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2018-05-15-place-ii!./.cache/json/works-2018-05-15-place-ii.json
// module id = 414
// module chunks = 231608221292675